import axios from "axios";
import { getToken } from "./api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const h = () => ({ Authorization: `Bearer ${getToken()}` });

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

let _reg = null;
export async function registerSw() {
  if (!("serviceWorker" in navigator)) return null;
  if (_reg) return _reg;
  try { _reg = await navigator.serviceWorker.register("/sw.js", { scope: "/" }); return _reg; } catch (e) { return null; }
}

const b64ToU8 = (s) => { const p = "=".repeat((4 - (s.length % 4)) % 4); const raw = atob((s + p).replace(/-/g, "+").replace(/_/g, "/")); return Uint8Array.from([...raw].map((c) => c.charCodeAt(0))); };

export async function currentSubscription() {
  const reg = await registerSw(); if (!reg) return null;
  return reg.pushManager.getSubscription();
}

export async function enablePush(app) {
  if (!pushSupported()) throw new Error("unsupported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("denied");
  const reg = await registerSw();
  await navigator.serviceWorker.ready;
  const { data } = await axios.get(`${API}/push/vapid-key`);
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: b64ToU8(data.key) });
  const j = sub.toJSON();
  await axios.post(`${API}/push/subscribe`, { endpoint: j.endpoint, keys: j.keys, app, ua: navigator.userAgent }, { headers: h() });
  return sub;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (!sub) return;
  const j = sub.toJSON();
  try { await axios.delete(`${API}/push/subscribe`, { data: { endpoint: j.endpoint, keys: j.keys }, headers: h() }); } catch (e) { /* noop */ }
  await sub.unsubscribe();
}

export const pushTest = async () => (await axios.post(`${API}/push/test`, {}, { headers: h() })).data;
export const myNotifications = async () => (await axios.get(`${API}/me/notifications`, { headers: h() })).data;
export const unreadNotifications = async () => (await axios.get(`${API}/me/notifications/unread-count`, { headers: h(), silent: true })).data;
export const markNotificationsRead = async (ids, all = false) => (await axios.post(`${API}/me/notifications/read`, { ids, all }, { headers: h() })).data;

// --- install prompt (Chrome/Edge/Android fire beforeinstallprompt; iOS needs the Share → Add to Home Screen hint) ---
let _prompt = null; const _subs = new Set();
if (typeof window !== "undefined") window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); _prompt = e; _subs.forEach((f) => f(true)); });
if (typeof window !== "undefined") window.addEventListener("appinstalled", () => { _prompt = null; _subs.forEach((f) => f(false)); });
export const canInstall = () => !!_prompt;
export const onInstallChange = (f) => { _subs.add(f); return () => _subs.delete(f); };
export async function promptInstall() { if (!_prompt) return null; _prompt.prompt(); const r = await _prompt.userChoice; _prompt = null; _subs.forEach((f) => f(false)); return r?.outcome; }

// Which "door" the visitor is in → manifest / icon / push subscription tag.
export function appFor(pathname) {
  if (pathname.startsWith("/family")) return "family";
  if (pathname.startsWith("/backoffice") || pathname.startsWith("/trainer") || pathname.startsWith("/staff-login")) return "staff";
  if (/^\/(kids|home|activities|activity|lesson|lessons|adventures|games|game|assignment|projects|paint|courses|join)/.test(pathname)) return "kids";
  return "buma";
}

// App-icon badge: Badging API where supported (installed PWA on Android, iOS 16.4+, desktop Chrome/Edge). Silently no-op elsewhere.
export async function setAppBadge(count) {
  if (!isStandalone() || !("setAppBadge" in navigator)) return;  // only meaningful for the installed app
  try { if (count > 0) await navigator.setAppBadge(count); else await navigator.clearAppBadge(); } catch (e) { /* unsupported */ }
}
